<template>
  <div class="c-error-notification">
    <v-snackbar
      v-model="errorMsg"
      color="red"
      :timeout="5000"
      @input="checkValue"
    >
      {{ errorMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="removeError"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>

export default {
  name: 'ErrorNotification',
  computed: {
    errorMsg: {
      get () {
        return this.$store.getters.getError
      },
      set (newVal) {}
    }
  },
  methods: {
    removeError () {
      this.$store.dispatch('setError', { errorMsg: '' })
    },
    checkValue (e) {
      if (!e) this.removeError()
    }
  }
}
</script>

<style lang="scss">
  .c-error-notification {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 9999;
  }
</style>
